import React from 'react';

export type StepType = 'PAST' | 'PRESENT' | 'FUTUR';

interface Props {
  stepNumber: number;
  stepName: string;
  type: StepType;
}

export const bubbleColors: Record<StepType, string> = {
  PAST: 'border-navy-blue bg-navy-blue text-white',
  PRESENT: 'border-navy-blue bg-white text-navy-blue',
  FUTUR: 'border-light-silver bg-whitesmoke text-sonic-silver',
};

const labelColors: Record<StepType, string> = {
  PAST: 'text-black',
  PRESENT: 'text-navy-blue',
  FUTUR: 'text-sonic-silver',
};

export const BreakdownStep: React.FC<Props> = ({ stepNumber, stepName, type }) => (
  <div className="flex flex-col items-center font-semibold">
    <span className={`rounded-full border-2 text-sm h-8 w-8 flex items-center justify-center ${bubbleColors[type]}`}>{stepNumber}</span>
    <span
      className={`font-normal md:text-xs text-[10px] absolute mt-10 w-[75px] md:w-fit md:fit-content flex justify-center text-center ${labelColors[type]}`}
    >
      {stepName}
    </span>
  </div>
);
